import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { ButtonsItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonsItemAttributes';

import ContentSettings from './ContentSettings';

const Content = (props: ComponentSettingsTab<ButtonsItemAttributes>) => (
  <AccordionTitle isInitiallyOpen title={__('Button')}>
    <ContentSettings {...props} />
  </AccordionTitle>
);

export default Content;
